import * as React from 'react';
import { FunctionComponent } from 'react';

export const Loader: FunctionComponent<{ message?: string }> = ({ message }) => {
  return (
    <div className={`bLoading${message ? ' flex-column' : ''}`}>
      <div className="spinner-border">
        <span className="sr-only">Loading...</span>
      </div>
      {message && (
        <div className="mt-3" role="status" aria-live="polite">
          {message}
        </div>
      )}
    </div>
  );
};

Loader.displayName = 'Loader';
